import axios from "axios";

export const state = {};

export const actions = {
  getRouteList({ dispatch, commit }, params) {
    return axios
      .get(appUrl + "/api/route", {
        params,
        headers: { Authorization: "Bearer auth sau" },
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
  getRouteStatistic({ dispatch, commit }, params) {
    return axios
      .get(appUrl + "/api/route/filter-statistic", {
        params,
        headers: { Authorization: "Bearer auth sau" },
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
};
